<template>
  <div class="wadder-div">
    <div class="bodder-div content-div">
      <div class="title-div center">淘号号极速版用户隐私政策</div>
      <div class="time-div">版本更新日期：2025年03月31日</div>
      <div class="top bold-div">
        【特别提示】请您仔细阅读《淘号号极速版隐私政策》（尤其是加粗的内容）并确定了解我们对您个人信息的处理规则，以帮助您了解维护自己个人信息权的方式。阅读过程中，如您有任何疑问，可及时与我们联系（联系方式以本隐私政策里所载的为准）。如您不同意本隐私政策中的任何条款，您应立即停止访问淘号号极速版平台。当您使用淘号号极速版平台提供的任一服务时，即表示您已同意我们按照本隐私政策来合法处理和保护您的个人信息。
      </div>
      <div class="top">引言：</div>
      <div>《淘号号极速版隐私政策》将帮助您了解以下内容：</div>
      <div>1、我们如何收集和使用您的个人信息</div>
      <div>2、我们如何使用Cookie和同类技术</div>
      <div>3、我们如何委托处理、向第三方提供、转让、公开披露您的个人信息</div>
      <div>4、我们如何保护您的个人信息</div>
      <div>5、您管理个人信息的权利</div>
      <div>6、我们如何处理未成年人的个人信息</div>
      <div>7、本隐私政策如何更新</div>
      <div>8、如何联系我们</div>
      <div class="top">
        <span class="bold-div">淘号号极速版APP（深圳市字节狂飙科技有限公司）</span
        >深知个人信息对您的重要性，我们尊重并保护所有使用淘号号极速版平台服务的用户的个人信息，并会尽全力保护您的个人信息安全可靠。同时，我们承诺将按业界的安全标准\采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品（或服务）前，仔细阅读并了解本《淘号号极速版隐私政策》（下称“本隐私政策”/“本政策”）。本隐私政策属于《淘号号极速版用户服务协议》不可分割的有效组成部分。
        如您对本隐私政策有任何疑问或您在使用我们提供的服务时对我们处理您的个人信息有任何疑问的，您可以通过<span
          class="bold-div"
          >官方客服渠道淘号号极速版（淘号号极速版—我的—客服中心）与我们取得联系</span
        >，我们将尽快给予您答复，及时解决您的困惑。
      </div>
      <div class="top">目录：</div>
      <div>一、我们处理个人信息的总原则</div>
      <div>二、本隐私政策的适用范围</div>
      <div>三、我们如何收集和使用您的个人信息</div>
      <div>四、我们如何使用Cookie和同类技术</div>
      <div>五、我们如何委托处理、对外提供、转让、公开披露您的个人信息</div>
      <div>六、我们如何存储及保护您的个人信息</div>
      <div>七、您管理个人信息的权利</div>
      <div>八、我们如何处理未成年人的个人信息</div>
      <div>九、本隐私政策的更新和通知</div>
      <div>十、如何联系我们</div>
      <div>十一、争议解决</div>
      <div class="title-div top20">一、我们处理个人信息的总原则</div>
      <div class="top">
        通常，我们会基于本隐私政策提示的功能收集您的个人信息。某些情况下，如果涉及其他信息的收集我们会单独向您出示个人信息保护说明条款。在处理您的个人信息方面，我们致力于保护您的个人信息安全，<span
          class="bold-div"
          >严格按照：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则，单独的个人信息保护说明条款优先适用</span
        >。如单独的个人信息保护说明条款未提及的内容，适用本政策。
      </div>
      <div class="title-div top20">二、本隐私政策的适用范围</div>
      <div class="top">
        本隐私政策适用于我们以<span class="bold-div"
          >淘号号极速版网站、淘号号极速版移动应用软件（APP）以及随技术发展出现的新形态向您提供的各项产品和服务</span
        >。除本隐私政策说明的相关信息收集使用活动外，本隐私政策不适用淘号号极速版平台用户及其他第三方向您提供的其他服务，其他服务适用于其向您另行说明的隐私政策或个人信息收集使用规则。

        <div class="title-div top20">三、我们如何收集和使用您的个人信息</div>
        <div class="top">
          本隐私政策所涉及指的个人信息或包含个人信息及敏感信息所包含的内容出自于《个人信息安全规范》个人信息。<span
            class="bold-div"
            >我们将在本条第(一)、第(二)款中详细论述我们基于以下所述功能，收集和使用您的个人信息的类型和目的</span
          >。
        </div>
        <div>
          个人信息是指以电子或者其他方式记录的能够单独与已识别或者与其他信息结合可识别特定的自然人身份或者反映特定自然人活动情况有关的各种信息，不包括匿名化处理后的信息。本隐私政策中涉及的个人信息包括：基本信息（包括<span
            class="bold-div"
            >个人姓名、生日、性别、电话号码）；个人身份信息（包括身份证、户口本或护照）；面部特征；</span
          >网络身份标识信息（包括系统账号、IP地址）；个人财产信息（银行账户、金融支付账户、交易和消费记录，以及优惠券、红包、兑换码等虚拟财产信息）；个人上网记录（包括括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备
          MAC
          地址、设备序列号、操作系统类型、应用列表（应用名称、应用包名、安装时间）及进程信息、唯一设备识别码
          IMEI/AndroidID/OAID/IDFA/OPENUDID/GUID、设备指纹信息、SIM 卡 IMSI
          信息等在内的描述个人常用设备基本情况的信息）；个人位置信息（包括<span
            class="bold-div"
            >行程信息、精准定位信息、经纬度等</span
          >）；个人设备权限信息（包括<span class="bold-div"
            >相册、相机、麦克风、通讯录、日历</span
          >等信息）。
          敏感个人信息是指一旦泄露、或者非法提供或滥用可能危害使用，容易导致自然人的人格尊严受到侵害或者人身和、财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等受到危害的个人信息。本隐私政策中涉及的敏感个人信息包括：<span
            class="bold-div"
            >您的财产信息（包括银行账户、金融支付账户、交易和消费记录等，以及优惠券、红包、兑换码等虚拟财产信息）；面部识别特征；个人身份信息（包括身份证、护照等身份证件信息）；网络身份识别信息（包括账户名、账户昵称）；其他信息（包括手机号码、网页浏览记录、行踪轨迹、精准定位信息、通讯录、好友列表）</span
          >。本隐私政策涉及到的敏感个人信息我们将以加粗方式提示您注意阅读。在您向淘号号极速版提供任何属于敏感个人信息前，请您清楚考虑该信息提供是恰当的并且同意您的敏感个人信息可按本隐私政策所述的目的和方式进行处理。我们会在得到您的同意后收集和使用您的敏感个人信息以实现与淘号号极速版业务相关的功能，并允许您对这些敏感信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相关功能。
        </div>
        <div>
          原则上，淘号号极速版平台仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息。但有鉴于淘号号极速版平台是综合类交易平台、虚拟物品交易平台，相较于实物商品交易平台风险更大，如果超过以下目的收集和使用您的个人信息时我们会单独另行向您提示告知并征得您的同意。
        </div>
        <div class="title-div top20">（一）帮助您成为我们的注册/登录用户</div>
        <div>
          1、您在使用淘号号极速版提供的服务时，为保障App正常运行、数据统计和安全风控，在您同意本隐私政策后，我们将进行集成SDK的初始化工作，会收集您的OpenUDID、AndroidID、IDFA、设备序列号、Mac地址、IMEI、IMSI、应用列表（应用名称、应用包名、安装时间）。同时，我们会向您申请“通知”权限，用于向您发送业务提醒、订单信息、聊天消息、活动和促销提醒，若您拒绝开通“通知”权限将无法收到前述提醒、信息、通知，但不会影响您正常使用淘号号极速版平台基本功能及服务。
        </div>
        <div>
          2、根据《中华人民共和国电子商务法》第二十七条的规定“电子商务平台经营者应当要求申请进入平台销售商品或者提供服务的经营者提交其身份、地址、联系方式、行政许可等真实信息，进行核验、登记，建立登记档案，并定期核验更新。”因此，当您选择成为我们的注册\登录用户时，您需要向我们提供您在微信平台的<span
            class="bold-div"
            >账户信息（包括头像、昵称、地区、性别）</span
          >、准备使用的用户名及您本人的<span class="bold-div">手机号码</span
          >，我们将通过发送短信验证码的方式来验证您的身份是否有效。您登录后可以继续完善您的账户信息，您可以修改补充您的头像、昵称、性别、出生日期、简介、<span
            class="bold-div"
            >电话号码</span
          >。同时，在您注册、登录淘号号极速版平台时，平台需要收集您的个人设备信息包括
          IMEI、SIM卡IMSI信息、AndroidID、设备序列号、IDFA、OAID。
        </div>
        <div>
          3、根据《中华人民共和国网络安全法》等相关法律法规，若您通过淘号号极速版进行信息发布、即时通讯、网络支付、购买交易，您需完成实名认证以确保您个人身份信息的真实性。实名认证需您提供您的<span
            class="bold-div"
            >姓名、身份证号码</span
          >至淘号号极速版，通过与公安网数据校验，来实现并保障实名信息的真实性。为保障平台交易安全和对您进行合法有效的保护，根据《中华人民共和国未成年人保护法》等相关法律法规，淘号号极速版出于反诈骗、保护未成年人、反洗钱、防止个人信息盗用、配合打击刑事犯罪以及平台风险控制目的，在触发相关风险场景下，需采集您的<span
            class="bold-div"
            >手机号或及面部生物识别信息至淘号号极速版</span
          >，由符合资质的第三方对您身份的进行核定。如您拒绝提供上述信息，将无法淘号号极速版平台有效的进行信息发布、即时通讯、购买交易，但不会影响您使用信息浏览、搜索服务。
        </div>

        <div>
          4、上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
        </div>
        <div class="title-div top20">（二）向您提供我们的产品或服务</div>
        <div>
          1、信息发布及交易功能淘号号极速版平台最主要的功能就是信息发布、商品搜索及交易功能。
        </div>
        <div>
          （1）当您使用发布功能时，我们会收集您的个人信息，<span
            class="bold-div"
            >包括实名信息、地理位置、相册</span
          >。此类信息为您自己主动填写的信息，收集是为了方便您能成功发布信息，可以更快捷的与您发布的内容进行匹配。
        </div>
        <div>
          （2）当您使用商品信息展示和搜索功能时，为了向您展示更契合您需求的商品或服务信息或让您快速地找到您所需要的商品，我们可能会收集您在访问或使用我们的的<span
            class="bold-div"
            >产品或服务的浏览、搜索记录及设备信息</span
          >（包括设备名称、设备序列号、设备型号、设备唯一识别码（IMEI/AndroidID/OAID/IDFA/OPENUDID/GUID）、操作系统和应用程序版本、语言设置、分辨率、服务提供商网络
          ID（PLMN）、WLAN接入点(如SSID、BSSID)、网络接入方式、蓝牙和基站信息、陀螺仪、重力感应传感器信息、应用列表（应用名称、应用包名、安装时间）和正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源）、服务日志信息（<span
            class="bold-div"
            >包括浏览记录、点击查看记录、搜索查询记录、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP
            地址、浏览器类型、电信运营商、使用语言、访问日期和时间）、浏览器类型</span
          >来为您提供商品信息展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品。
          请您注意，您的搜索关键词信息无法单独识别您的身份，不属于您的个人信息，我们有权以任何的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。
        </div>
        <div>
          （3）当您使用交易功能（包括下单、支付、交付产品或服务、客服及售后）时，我们会相应收集您的个人信息如下：
        </div>
        <div>
          <div>
            ①下单功能：
            A、当您下单购买商品或服务时，订单中会载明订单号、您所购买的商品或服务信息、您应支付的货款金额及支付方式，我们会将前述信息同步至商品出售方以实现您的有效购买。
            上述所有信息构成您的“订单信息”，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
          </div>
          ②支付功能：
          A、付款功能：在您下单后，您可以选择与淘号号极速版合作的第三方支付机构（包括微信支付、支付宝，以下称“支付机构”）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的<span
            class="bold-div"
            >淘号号极速版订单号与交易金额信息</span
          >与这些支付机构共享以实现其确认您的支付指令并完成支付。
          B、收款功能：若您通过淘号号极速版平台出售物品、使用退款功能、账户提现以及其他需要向您支付费用的情况下，我们需要收集您的收款账户信息（账号、开户行/支付机构名称、户名）以支持您的收款需求。
        </div>
        <div>
          ③交付产品或服务功能：众所周知，虚拟物品交易以线上发送虚拟卡券或账号使用权、所有权转让为主，不存在实物交易；在当您下单并选择在线完成支付或回收订单下单后，与我们或淘号号极速版平台用户商品出售方、账号回收方将根据商品特殊属性，通过发送电子卡券、账号密码、账号换绑等形式完成订单的交付。
        </div>
        <div>
          ④客服与售后功能：我们的在线客服和售后功能会使用您的<span
            class="bold-div"
            >账号信息和订单信息</span
          >。为保证您的账号安全，我们的在线客服及电话客服会使用您的<span
            class="bold-div"
            >账号信息</span
          >与您核验您的身份，并记录您与客服之间的通话记录、咨询记录，以便为您提供适当的帮助和处理。当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。
        </div>
        <div>2、搜索/订阅功能</div>
        <div>
          当使用淘号号极速版提供的搜索功能时，我们会收集您查询的关键字信息以及您在使用淘号号极速版服务时所浏览或要求的其他信息和内容详情。为了给您带来更便捷的搜索服务并不断完善淘号号极速版产品或服务。该关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本隐私政策的限制范围内。只有当您的搜索关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本政策对其进行处理与保护。
        </div>
        <div>3、客户服务</div>
        <div>
          当您向淘号号极速版发布信息、申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们需要您提供<span
            class="bold-div"
            >姓名、手机号码、订单号码</span
          >。如您拒绝提供上述信息，可能部分功能无法使用，同时无法向您及时反馈申诉或咨询结果。为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构与交易进度相关的您的交易、支付，或将您的交易信息共享给上述服务提供者。
        </div>

        <div>4、营销活动</div>

        <div>
          我们将会时不时举办线上或线下的营销活动，包括邀请用户奖励红包、赠送实体物品及同类活动。在此类营销活动中，我们可能需要用户<span
            class="bold-div"
            >提供个人信息（姓名、手机号、地址信息)</span
          >，以便我们能够给用户发放奖励或寄送礼品。在淘号号极速版向您支付费用的情况下，我们需要收集您的的<span
            class="bold-div"
            >收款账户信息（账号、开户行/支付机构名称、户名）</span
          >。
        </div>
        <div>5、为您提供更多服务</div>
        <div>
          （1）基于摄像头（相机）的服务功能：您可以在开启摄像头/相机权限后使用该功能完成照片或视频的拍摄及上传、推广信息的编辑发布、扫码，或通过该功能完成信息的查阅，以及特定场景下经您授权的人脸识别功能。当您使用该附加功能进行人脸识别时，我们会收集您的，且严格在经您授权同意的范围内使用，未来如我们拟使用您的面部信息为您提供其他产品及/或服务功能的，我们会再次与您确认。
        </div>
        <div>
          （2）基于相册（图片库/视频库）的图片/视频访问及上传的附加功能：您可以在开启
          iOS 系统相册权限或
          Android系统存储权限后使用该功能上传您的照片/图片/视频来实现您想要发布的推广信息的编辑发布、拍照购物、个人资料头像及介绍视频的上传或与客服及淘号号极速版平台其他用户沟通时发送图片功能（如照片存储在外置
          SD 卡中，则需要调取 SD 卡中照片信息）。
        </div>
        <div>
          （3）基于通讯录的附加功能：在您添加紧急联系人等时可以便利地取用您通讯录内的联系人信息，无需在手动输入。
        </div>
        <div>
          （4）基于精确定位的附加功能：通过全球定位系统（GPS）或网络位置信息（基于基站和WLAN）获取精准地理位置信息，便于您在发布商品是添加位置，用于完成安全保障以及基于地理位置的服务（LBS）等相关功能。
        </div>
        <div>
          （5）基于方向传感器/加速度传感器的附加功能：通过设备方向传感器获取设备正确指向，便于您在录制视频过程中保持视频方向正确。
        </div>
        <div>
          （6）基于悬浮窗的附加功能：在您开启悬浮窗权限后，您可以使用此功能完成账号租赁业务。
        </div>
        <div>
          （7）基于电话或手机信息的附加功能：在您开启电话权限或手机信息权限后，您可以使用该权限实现手机号一键登录功能，我们将会收集您得<span
            class="bold-div"
            >手机号码及设备的 IMEI、SIM 卡 IMSI 信息</span
          >以实现前述功能。
        </div>

        <div>
          （8）基于剪贴板/剪切板的附加功能：您可以在开启剪贴板/剪切板权限后实现商品或活动分享时复制链接功能、交易过程中复制订单号。在前述功能中我们需要收集并识别您的口令内容。上述附加功能可能需要您在您的设备中向我们开启您的<span
            class="bold-div"
            >地理位置（位置信息）、相机（摄像头）、相册（图片库）、存储、麦克风、通讯录、日历、悬浮窗、电话或手机信息、广告跟踪</span
          >，以实现这些功能所涉及的信息的收集和使用。我们将在您首次下载APP或者具体使用到上述所列功能时逐一以弹窗的形式提前向您提示，您可以根据您的需要进行选择。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的信息的收集及使用。
          若您提供的信息中含有其他用户的个人信息，在向淘号号极速版平台提供这些个人信息之前，您需确保您已经取得合法的授权。
        </div>

        <div>
          （9）自启动和关联启动说明如下：
          <br />
          a、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用
          (自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。
          <br />
          b、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。
          <br />
          c、当您打开本App内部下载更新APP后，会监听文件下载完成广播，可能会被提示自启动或关联启动，单并不涉及自启动或关联启动，请放心更新。
        </div>

        <div>7、其他服务</div>
        <div>
          （1）除上述淘号号极速版向您提供的产品和服务外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时所提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。与此同时，为提高您使用淘号号极速版平台提供产品与/服务的安全性，更准确地预防钓鱼网站欺诈、木马病毒和恶意程序、保护账户安全，我们可能会通过了解一些您的<span
            class="bold-div"
            >浏览信息、订单信息、您的应用列表（应用名称、应用包名、安装时间，通过
            SDK 形式）、操作系统类型、设备型号、设备序列号、设备 MAC
            地址、设备唯一识别码（IMEI/androidID/IDFA/OPENUDID/GUID）</span
          >来判断您账户的风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息（包括
          IDFA、OPENUDID、android
          ID、设备序列号）对于淘号号极速版系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。为了更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入及同类安全风险，更准确地识别违反法律法规或淘号号极速版相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息（包括IDFA、OPENUDID、AndroidID、设备序列号、系统版本号、设备名称、当前网络类型）、有关网络日志以及淘号号极速版的关联方、合作伙伴及其他独立第三方来源依据法律的规定或征得您授权同意的前提下向淘号号极速版分享您的个人信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        </div>
        <div>
          （2）在不透露单个用户隐私资料的前提下，淘号号极速版有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。淘号号极速版可能会对网络服务使用情况进行统计。同时，淘号号极速版可能会与公众分享这些统计信息，以展示我们服务的整体使用趋势。这些统计信息不包含您的任何身份识别信息。
        </div>

        <div>
          （3）App内存在即时聊天功能，为保持聊天功能正常使用，App内会监听部分系统广播、可能会有自启动、关联启动等情况。请放心使用，如有疑问可以在本隐私政策底部找到我司工作人员电话和邮箱联系我们，我们将为您解答相关问题
        </div>
        <div class="title-div top20">（三）征得授权同意的例外</div>
        <div>
          <span class="bold-div"
            >您充分知晓，根据相关法律，除您同意我们收集您的个人信息的情形外，基于以下情形，我们也可以收集您的个人信息而无需您的同意：</span
          >
        </div>
      </div>
      <div>（1）为订立、履行您作为一方当事人的合同所必需；</div>
      <div>（2）为履行法定职责或者法定义务所必需；</div>
      <div>
        （3）为应对突发公共卫生事件，或者紧急情况下为保护您或其他自然人的生命健康和财产安全所必需；
      </div>
      <div>
        （4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内收集个人信息；
      </div>
      <div>
        （5）依照本法规定在合理的范围内收集您自行公开或者其他已经合法公开的个人信息；
      </div>
      <div>（6）法律、行政法规规定的其他情形。</div>
      <div class="title-div top20">（四）个人信息的使用规则</div>
      <div>
        我们会根据本政策的约定为实现产品或服务功能的目的使用您的个人信息。当我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以适当的方式再次征求您的同意。
        我们收集的敏感个人信息已在本政策中通过显著标识进行展示。一旦您的敏感个人信息被泄露、篡改或被非法使用，将会对您的人身或财产安全造成损害。为防止您的敏感个人信息被泄露或被非法使用，我们已采取适当的技术和组织保护措施，尽力保障您的信息安全。
        随着我们的产品与服务的升级迭代，我们可能会对本政策描述的业务功能及对应收集使用的个人信息类型进行调整。当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。当我们要将您的个人信息用于与原处理目的无直接或合理关联的场景，或本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，我们会通过更新本政策、相关产品页面等隐私文档并通过弹窗、站内信、推送信息等多种方式向您告知，并事先征求您的同意。
        请您注意，您在使用我们的产品或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。如我们停止运营淘号号极速版产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
      </div>

      <div class="title-div top20">四、我们如何使用Cookie和同类技术</div>
      <div>（一）Cookies的使用</div>
      <div>
        为使您获得更轻松的访问体验，您访问淘号号极速版平台相关网站或使用淘号号极速版平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是
        Cookie，Flash
        Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
        请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以在相关的页面修改对Cookie
        的接受程度或者拒绝淘号号极速版的
        Cookie，但这一举动在某些情况下可能会影响您安全访问淘号号极速版相关网站和使用淘号号极速版平台提供的服务。
      </div>
      <div class="title-div top20">
        五、我们如何委托处理、对外提供、转让、公开披露您的个人信息
      </div>
      <div></div>
      <div>（一）委托处理</div>
      <div>
        为了提升信息处理效率，降低信息处理成本或提高信息处理准确性，或【委托处理的目的】，我们可能会委托有能力的我们的关联公司或其他【受托方类型，例如：短信发送服务提供商；软件、系统技术服务提供商；营销和研究、数据分析服务提供商；地图服务提供商；发票服务提供商；网站/系统服务器托管服务提供商。】代表我们来处理用户信息，但我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经用户授权的用途。委托关系解除后，受托方将不再保存您的个人信息。
      </div>
      <div>（二）对外提供</div>
      <div>
        一般情况下，我们不会与向淘号号极速版以外的任何公司、组织和个人分享提供您的个人信息，但以下情况除外：
      </div>
      <div>
        1、在获得单独同意的情况下共享：获得您或您的监护人的单独同意后，或您主动要求我们与第三方共享您的个人信息的，我们会与其他方共享您的个人信息。
      </div>
      <div>2、具备法律规定的其他合法事由，我们与第三方共享您的个人信息；</div>
      <div>
        3、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
      </div>
      <div>
        4、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。
      </div>
      <div>
        5、与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型：
      </div>
      <div>
        （1）商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们的供货或提供基础设施技术服务（如电子设备厂商）、支付服务（如微信支付、支付宝）、风险控制。我们共享这些信息的目的是可以实现我们产品与/或服务的核心购物功能，比如我们必须与手机厂商共享您的设备指纹信息以便其向您提供手机系统信息发送和展示通知信息的服务（如私信通知、交易信息通知、运营活动通知及其他同类通知）货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付。
      </div>
      <div>
        （2）第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。
      </div>

      <div>
        6、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
      </div>
      <div>
        7、只有共享您的信息，才能提供您需要的服务或处理您与他人的纠纷或争议。
      </div>
      <div>
        8、您通过点击相关产品的相应按键同意向第三方提交个人信息（包括但不限于“帮我申请”、“帮我提交”、“立即申请”等按键）。
      </div>
      <div>
        9、我们与第三方进行联合营销活动，我们可能与其共享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式及淘号号极速版账号，以便第三方能及时向您发放奖品；
      </div>
      <div>
        10、如您出现违反中国有关法律、法规或者违反您与我们签署的相关协议（包括在线签署的电子协议）及相关规则时，需要向第三方披露；
        关于我们对外提供个人信息的情况，请查看<span
          class="third-div"
          @click="toDetail"
          >《第三方信息收集清单》</span
        >
      </div>
      <div></div>
      <div>（三）转让</div>
      <div>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        2、在涉及合并、收购或破产清算等类似的交易时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意，除非具备其他合法事由。
        3、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
        4、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。
      </div>
      <div>（四）公开披露</div>
      <div>我们仅会在以下情况下，公开披露您的个人信息：</div>
      <div>1、获得您明确单独同意后；</div>
      <div>
        2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向上述监管部门披露您的个人信息。
      </div>
      <div>
        我们知晓对外共享提供、转让、公开披露个人信息所承担的相应法律责任。我们承诺按照本条款的要求共享提供、转让、公开披露您的个人信息，按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗、提示等形式征得您的同意或确认第三方已经征得您的同意。
        因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过本隐私政策文首处提供的联系方式操作。
        根据相关法律法规及国家标准，在以下情形中，我们对外提供、转让、公开披露您的个人信息无需事先征得您的单独同意:
      </div>
      <div>（1） 为订立、履行您作为一方当事人的合同所必需；</div>
      <div>（2） 为履行法定职责或者法定义务所必需；</div>
      <div>
        （3）
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      </div>
      <div>
        （4）
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内收集个人信息；
      </div>
      <div>
        （5）
        依照法律规定在合理的范围内收集的您自行公开或者其他已经合法公开的个人信息；
      </div>
      <div>（6） 法律、行政法规规定的其他情形。</div>
      <div>（六）第三方SDK的使用</div>
      <div>
        为保障我们客户端的稳定运行、功能实现，使您能够使用享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似应用程序，例如当您使用手机设备时，手机厂商提供的Push
        SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。我们会及时向您说明涉及收集使用用户信息的第三方SDK的最新情况，这些第三方sdk的名称、提供方、收集个人信息的目的及类别分别是：
      </div>



      <div class="top-text-tip">
        <span class="bold">融云音视频通话(含UI版)</span>
        <br />
        涉及个人信息：手机号码、用户身份信息 使用目的：用户间的即时通讯
        <br />
        使用场景：在用户使用App时使用
        <br />
        合作方主体：北京云中融信网络科技有限公司
        <br />
        收集方式：SDK采集
        <br />
        官网链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.rongcloud.cn/?utm_source=baiduBrand&utm_term=title"
          >https://www.rongcloud.cn/?utm_source=baiduBrand&utm_term=title</a
        >

        <br />
        隐私权政策链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.rongcloud.cn/protocol?_sasdk=dMTgyNDliNDA4ZDc4NTYtMDhkNTgyNDg1NzE2ZDM4LTU3NjE1M2UtMjcxMDgyNS0xODI0OWI0MDhkODhiNA"
          >https://www.rongcloud.cn/protocol?_sasdk=dMTgyNDliNDA4ZDc4NTYtMDhkNTgyNDg1NzE2ZDM4LTU3NjE1M2UtMjcxMDgyNS0xODI0OWI0MDhkODhiNA</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold"
          >友盟+社会化分享SDK、友盟+应用性能监控SDK、友盟+移动统计SDK</span
        >
        <br />
        涉及个人信息：设备识别信息（含设备序列号、设备标识符、AndroidID、OAID、iOS广告标识符、IP地址、互联网服务提供商及网络状态）、IMSI、安装应用列表、浏览器、会话启动/停止时间
        <br />
        使用目的：用于统计、分析数据、提供基础反作弊能力、设备应用性能监控服务
        <br />
        使用场景：在用户使用App时使用
        <br />
        合作方主体：友盟同欣（北京）科技有限公司
        <br />
        收集方式：SDK采集，收集信息的目的方式范围请查看下方sdk隐私政策
        <br />
        官网链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://developer.umeng.com/docs/147377/detail/210024"
          >https://developer.umeng.com/docs/147377/detail/210024</a
        >

        <br />
        隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://developer.umeng.com/docs/147377/detail/209997"
          >https://developer.umeng.com/docs/147377/detail/209997</a
        >
        <br />
      </div>

      <div class="top-text-tip">
        <span class="bold">腾讯QQ互联、微信OpenSDK Android</span> <br />
        涉及个人信息：设备序列号、设备标识符（Android如IMEI、Android
        ID、OAID、IMSI、ICCID、MEID、Serial，iOS如IDFV、IDFA）、位置信息（如GPS、WLAN接入点）、运营商信息、WI-FI地址、运营商信息、应用列表
        <br />
        使用目的：分享功能 使用场景：在用户分享时使用
        <br />
        合作方主体：深圳市腾讯计算机系统有限公司
        <br />收集方式：SDK采集 <br />官网链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://open.tencent.com/"
          >https://open.tencent.com/</a
        >
        <br />
        隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E"
          >https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E</a
        >

        <br />
      </div>

      <div class="top-text-tip">
        <span class="bold">易盾</span>

        <br />涉及个人信息：设备序列号、设备标识符（Android如IMEI、Android
        ID、OAID、IMSI、ICCID、MEID、Serial，iOS如IDFV、IDFA）、应用列表
        <br />
        使用目的：设备唯一标识 使用场景：在用户使用App时使用
        <br />
        合作方主体：杭州网易智企科技有限公司
        <br />
        收集方式：SDK采集
        <br />官网链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://dun.163.com/"
          >https://dun.163.com/
        </a>
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://dun.163.com/clause/privacy"
          >https://dun.163.com/clause/privacy</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">腾讯浏览服务 X5 网页引擎 SDK</span>

        <br />收集类型：设备型号、操作系统、CPU类型、网络状态参数等
        <br />
        使用目的：优化移动端webview体验的整套解决方案
        <br />
        合作方主体：深圳市腾讯计算机系统有限公司
        <br />
        收集方式：SDK采集
        <br />官网链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://open.tencent.com/"
          >https://open.tencent.com/
        </a>
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://rule.tencent.com/rule/preview/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d"
          >https://rule.tencent.com/rule/preview/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">小米推送</span>

        <br />涉及个人信息：设备序列号、IMEI/OAID 编号、GAID 编号、IMSI
        编号、MAC 地址、序列号、MIUI 版本及类型、ROM 版本、Android 版本、Android
        ID、Space ID、SIM
        卡运营商和归属地、屏幕显示信息、设备输入信息、设备激活时间、设备制造商信息和型号名称、网络运营商、连接类型、硬件基础配置信息
        <br />
        使用目的：提供小米品牌的手机消息推送服务
        <br />
        合作方主体：北京小米移动软件有限公司
        <br />
        收集方式：SDK采集
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://dev.mi.com/distribute/doc/details?pId=1534"
          >https://dev.mi.com/distribute/doc/details?pId=1534</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">vivo PUSH-SDK</span>

        <br />涉及个人信息：设备序列号、设备标识信息(如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android
        ID）、使用推送服务的应用软件信息（如应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络类型、国家码、设备类型、设备型号、操作系统版本、当前网络类型、消息发送结果、通知栏状态
        <br />
        使用目的：提供VIVO品牌的手机消息推送服务
        <br />
        合作方主体：维沃移动通信有限公司
        <br />
        收集方式：SDK采集
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://dev.vivo.com.cn/documentCenter/doc/652"
          >https://dev.vivo.com.cn/documentCenter/doc/652</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">OPPO PUSH 客户端SDK</span>

        <br />涉及个人信息：设备序列号、设备相关信息（如IMEI或OAID，Serial
        Number，IMSI，User ID，Android ID，Google Advertising ID,
        手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）
        <br />
        使用目的：提供OPPO品牌的手机消息推送服务
        <br />
        合作方主体：OPPO广东移动通信有限公司
        <br />
        收集方式：SDK采集
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://open.oppomobile.com/new/developmentDoc/info?id=10288"
          >https://open.oppomobile.com/new/developmentDoc/info?id=10288</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">华为推送SDK</span>

        <br />涉及个人信息：设备序列号、应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息
        <br />
        使用目的：1、提供消息推送服务；2、统计华为推送SDK接口调用成功率。
        <br />
        合作方主体：华为软件技术有限公司
        <br />
        收集方式：SDK采集
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
          >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">创蓝闪验</span>
        <br />涉及个人信息：设备信息、位置信息、网络信息、SDK
        认证相关请求结果、私网IP、设备标识符（IMEI、IDFA、Android ID、MAC、OAID
        相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）
        <br />
        使用目的：用于实现App一键登录和验证用户手机号码与本机流量卡号是否一致的服务、私网IP用于和蜂窝网络网关分配的ip作比较，防止通过连接热点登陆其他用户号码；
        用于用户认证安全检验
        <br />
        合作方主体：上海璟梦信息科技有限公司
        <br />
        收集方式：SDK采集
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://static.253.com/chuanglan/flash-policy.html"
          >https://static.253.com/chuanglan/flash-policy.html</a
        >
        <br />
        闪验SDK 同时集成了第三方 SDK，使用本服务时需遵守相应协议，参考如下：
        <br />

        <span class="bold">中国移动</span>
        收集信息名称：网络类型、网络地址、运营商类型、本机号码、手机设备类型、手机操作系统、硬件厂商
        目的及其用途：识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制
        信息处理方式：SDK 自行采集 第三方主体：中移互联网有限公司
        协议名称：《中国移动认证服务条款》 协议链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="http://wap.cmpassport.com/resources/html/contract.html"
          >http://wap.cmpassport.com/resources/html/contract.html</a
        >
        <br />

        <span class="bold">中国联通</span>
        收集信息名称：网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商
        目的及其用途：识别⽤户的⼿机号码快速登录/号码校验 信息处理方式：SDK
        自行采集 第三方主体：中国联合网络通信有限公司
        协议名称：《中国联通服务与隐私协议条款 》 协议链接：<a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://ms.zzx9.cn/html/oauth/protocol2.html"
          >https://ms.zzx9.cn/html/oauth/protocol2.html</a
        >
        <br />
        <span class="bold">中国电信</span>
        收集信息名称：网络 IP
        地址、网络类型、注册手机号码、本机号码、国际移动用户标识码、应用进程信息、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本
        目的及其用途：识别⽤户的⼿机号码快速登录/号码校验及业务风控
        信息处理方式：SDK 自行采集 第三方主体：世纪龙信息网络有限责任公司
        协议名称：《天翼服务及隐私协议》 协议链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://e.189.cn/sdk/agreement/detail.do?hidetop=true"
          >https://e.189.cn/sdk/agreement/detail.do?hidetop=true</a
        >
      </div>

      <div class="top-text-tip">
        <span class="bold">APP支付客户端SDK</span>
        <br />
        涉及个人信息：可变更设备唯一标识、基本设备信息（安卓ID、OAID、MAC地址、IDFV，移动广告标识符（如苹果IDFA或谷歌广告ID）、软件安装列表以及网络信息。为实现网络链路的选择和优化，以提升用户体验，我们需要收集和使用网络信息。
        <br />
        使用目的：用户支付。
        <br />
        收集方式：SDK采集
        <br />
        合作方主体：支付宝(杭州)信息技术有限公司
        <br />隐私权政策链接：
        <a
          class="blueColor"
          target="_blank"
          rel="noopener noreferrer"
          href="https://opendocs.alipay.com/open/54/01g6qm"
        >
          https://opendocs.alipay.com/open/54/01g6qm</a
        >
      </div>

      <div class="title-div top20">六、我们如何存储及保护您的个人信息</div>
      <div></div>
      <div>（一）信息存储</div>
      <div>
        淘号号极速版收集的有关您的信息和资料将保存在淘号号极速版及（或）其关联公司的服务器上，这些信息和资料全部储存在中国境内。目前，淘号号极速版的产品和服务不会涉及到数据的跨境传输，如果我们的产品/服务发生变更，涉及数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。
      </div>
      <div>（二）信息保护</div>
      <div>
        为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于
        SSL、信息加密存储、数据中心的访问控制。
      </div>
      <div>
        1、数据加密：我们对于用户的微信名称、用户名、手机号等进行加密存储，保证用户基本信息不会被恶意获取；
      </div>
      <div>
        2、身份鉴别：我们通过微信授权验证或者账号绑定手机验证码或身份证号及面部特征识别验证，进行用户身份合法性鉴别，防止非经授权的介入；
      </div>
      <div>
        3、访问控制：我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。淘号号极速版用户在进行身份鉴别后，才能查询并管理用户信息和资源，未经过身份鉴别，不能管理用户资源；
      </div>
      <div>
        4、安全审计：我们有时会接入风控平台或认证平台，对一些场景或行为进行监测。如通过流量分析，完成账号异常登陆、注册及其他异常行为的监控。淘号号极速版会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失；
      </div>
      <div>
        5、账号保护：您的账户均有安全保护功能，请妥善保管您的微信账号、手机号码和验证码。我们将通过向其它服务器备份及其他安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，在信息网络上也不存在“完善的安全措施”。我们强烈建议您不要使用非淘号号极速版推荐的通信方式发送个人信息。如因您自己的原因导致账户信息泄露而造成的任何法律后果需由您本人负责。
        在使用淘号号极速版平台服务进行网上交易时，如您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息（例如联系人、联络方式），请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的淘号号极速版账户安全，或者给您造成其他的损失的，请您务必在第一时间根据本隐私政策提到的联系方式与我们取得联系，以便我们采取相应措施维护您的淘号号极速版账户安全，防止损失的发生或者进一步扩大。为避免疑义，如果您未在第一时间通知淘号号极速版客服，则您应自行承担由此给您造成的损失（及扩大的损失）。
      </div>
      <div>
        6、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
      </div>
      <div class="title-div top20">七、您管理个人信息的权利</div>
      <div></div>
      <div>
        我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问您对您的个人信息享有知情权与决定权。在您使用我们的产品与/服务期间，您可以通过相应页面提示或本隐私政策载明的方式联系我们，以查询、复制、转移、拒绝或限制处理、更正、删除以及撤回同意补充、删除您的个人信息，以及行使改变授权同意的范围与注销账号的权利，我们会及时处理您的请求。我们会尽全力保护您对于自己个人信息的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
      </div>
      <div>（一）个人信息的查询、更正</div>
      <div>
        您有权访问查询您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权个人信息查询权，可以通过以下方式自行访问查询：APP端：您可以通过首页下方“我的”—点击右上角的设置—“个人资料”，访问查询、更改您的个人资料信息、账号信息等。具体如下：
      </div>
      <div>
        （1）您的账户信息：APP
        端具体路径为：首页下方“我的”-点击右上角的设置-“个人资料”，管理您的头像、昵称、性别、生日、个人简介等。
      </div>
      <div>
        （2）您的实人认证信息：APP
        端具体路径为：首页下方“我的”-点击右上角的设置-“账户与安全”-“实名认证”。您可以进行实名认证。如您需要更改实名认证信息，请联系淘号号极速版客服协助重新认证。
      </div>
      <div>
        （3）您的订单信息：APP
        端具体路径为：首页-“我的”-“我购买的/我销售的”。您可以选择删除已经完成的订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务。
      </div>
      <div>
        （4）您的浏览和关注信息：您可以访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。APP
        端路径为：首页-“我的”-“足迹/收藏/关注”。
      </div>
      <div>
        （5）您的账单信息：APP
        端具体路径为：首页-“我的”-“钱包”-“账单”，您可以查看支付、退款、收款、冻结、充值、提现等信息。
      </div>
      <div>
        （6）您的隐私设置：您可以查看或修改您的隐私设置，提醒设置、语音通话权限设置、系统权限（如地理位置、相机、相册、麦克风等）设置。APP
        路径为：首页下方“我的”—点击右上角的设置—“隐私设置”。
      </div>
      <div>
        （7）对于您在使用我们的产品与/或服务过程中产生的其他个人信息：如应用列表（应用名称、应用包名、安装时间）、设备信息（设备序列号、IMEI、SIM卡IMSI信息、MAC地址、广告标识符IDFA、AndroidID、OAID、设备品牌型号、设备操作系统）等，需要查询或更正的，请随时按照本隐私政策“响应您的上述请求”条款中列明的途径联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
        您无法访问查询和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问在线查询和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问查询和更正，但您可联系我们进行删除或做匿名化处理，我们会根据实际情况在技术可行的前提下响应您的请求。
      </div>
      <div>（二）个人信息的删除</div>
      <div>
        除了您在上述查询、更正信息的页面进行信息删除处理外，您还可以在 APP
        首页下方“我的”—右上角“设置”—选择“缓存清理”。在以下情形中，您可以向我们提出删除个人信息的请求：
      </div>
      <div>
        （1）本政策中声明的处理目的已实现、无法实现或者为实现处理目的不再必要；
      </div>
      <div>（2）基于同意处理您的个人信息，您撤回同意的；</div>
      <div>
        （3）我们违反法律、行政法规或与您的约定收集、使用、存储您的(4)个人信息；
      </div>
      <div>
        （4）我们违反法律、行政法规或与您的约定向第三方提供您的个人信息，我们将立即停止信息传输行为，并通知第三方及时删除；
      </div>
      <div>
        （5）我们违反法律、行政法规规定或与您的约定，公开披露您的个人信息，我们将立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；
      </div>
      <div>（6）您不再使用我们的产品或服务，或您注销了淘号号极速版账户的；</div>
      <div>（7）我们停止提供产品或者服务；</div>
      <div>（8）法律法规规定的其他情形。</div>
      <div>
        若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </div>
      <div>（三）改变您授权同意的范围或撤回您的授权</div>
      <div>
        您可以通过删除信息、在淘号号极速版软件中进行隐私权限设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </div>
      <div>
        （四）共享、转让、公开披露个人信息时事先征得授权同意的例外根据法律规定，在以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
      </div>
      <div>（1）与国家安全、国防安全直接相关的；</div>
      <div>（2）与公共安全、公共卫生、重大公共利益直接相关的；</div>
      <div>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
      <div>
        （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </div>
      <div>（5）个人信息主体自行向社会公众公开的个人信息；</div>
      <div>
        （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </div>
      <div>（五）注销账户</div>
      <div>
        您可以在我们的产品或服务中直接申请注销账户。关于您注销账户的方式以及您应满足的条件，请详见“注销账户”页面。您注销账户后，我们将停止为您提供产品或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。
        “注销账户”页面的查询方式： APP 端：APP
        首页下方“我的”—右上角“设置”—“个人资料”—“注销账户”。
      </div>
      <div>（六）约束信息系统自动决策</div>
      <div>
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式，供您拒绝我们仅依据自动化决策机制做出决定。
      </div>
      <div>（七）其他个人信息权利</div>
      <div>
        在符合相关法律规定的情况下，您的近亲属可以对您身后的相关个人信息行使上述查阅、复制、更正、删除等权利；但您另有安排的除外。
      </div>
      <div>（八）响应您的上述请求</div>
      <div>
        您的任何疑问、建议、意见及投诉，可以通过“淘号号极速版APP-我的-客服中心”提交。为保障安全，我们将在必要的身份验证通过后进行处理，最长将在不超过15个工作日或法律法规规定期限内作出答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如需要开发新系统或从根本上改变现行惯例）、给他人隐私权带来风险或者非常不切实际（例如涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
      </div>
      <div>（1）与我们履行法律法规规定的义务相关的：</div>
      <div>（2）与国家安全、国防安全有关的；</div>
      <div>（3）与公共安全、公共卫生、重大公共利益有关的；</div>
      <div>（4）与犯罪侦查、起诉、审判和执行判决等有关的；</div>
      <div>（5）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</div>
      <div>
        （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
      </div>
      <div>
        （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      </div>
      <div>（8）涉及商业秘密的。</div>
      <div class="title-div top20">八、本隐私政策的更新和通知</div>
      <div>
        我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。每当隐私政策更新时，我们会通过站内信以公告的方式通知您，您可以选择查看或忽略。
        对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过
        push 通知、短信等发送通知，说明隐私政策的具体变更内容）。
      </div>
      <div>本隐私政策所指的重大变更包括但不限于：</div>
      <div>
        1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
      </div>
      <div>
        2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
      </div>
      <div>3、个人信息共享、转让或公开披露的主要对象发生变化；</div>
      <div>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
      <div>
        5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
      </div>
      <div>6、个人信息保护影响评估报告表明存在高风险时。</div>
      <div class="title-div top20">九、如何联系我们</div>
      <div>
        如您对本隐私政策有任何疑问或您提供的上述个人信息受到了侵扰，您可以通过淘号号极速版在线客服渠道与我们联系，我们将在收到您的请求并核实您的身份后尽快给予您答复。一般情况下，我们将在十五天内（国家法定节假日顺延）或法律规定的期限内回复。
      </div>

      <div class="title-div top20">十、开发者联系方式</div>
      <div>
        如果您对我们的产品功能或者页面交互有更好的建议，可以通过以下方式联系开发团队，我们很乐意得到你们的反馈。
      </div>
      <div>1、手机号码：15323795023</div>
      <div>2、电子邮箱：15323795023@163.com</div>
      <div class="title-div top20">十一、争议解决</div>
      <div>
        1、如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以向网信办及工商登监管部门进行反馈。
      </div>
      <div>
        2、因本隐私政策以及我们处理您个人信息事宜引起的任何争议，任何一方应向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  
  setup() {
    const router = useRouter();

    function toDetail() {
      console.log("3213123213123123");
      router.push({
        path: "/thirdInfo",
      });
    }
    return { toDetail };
  },
};
</script>

<style scoped>
.title-div {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 20px;
  margin-bottom: 10px;
}
.center {
  text-align: center;
}
.top {
  margin-top: 10px;
}
.top20 {
  margin-top: 20px;
}
.content-div {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 22px;
}

.bodder-div {
  padding: 24px 12px;
  box-sizing: border-box;
}
.time-div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  color: #666;
  font-size: 14px;
  font-weight: bold;
}
.bold-div {
  font-weight: bold;
}
.third-div {
  color: #3167fd;
}
.top-text-tip {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: normal;
  color: #000000;
  line-height: 22px;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 13px;
  word-break: break-all;
}
.bold {
  font-weight: bold;
  font-size: 15px;
}
.blueColor {
  color: #3167fd;
}
</style>
